module.exports = __webpack_public_path__ + "static/banner-2-95679694f30688667832d409a08d30d3.jpg";